export function newClientId(): string {
  try {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  } catch {
    /* ignore */
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function toAdditionalResubmitPayload(
  payload: Record<string, unknown>,
  reason: string
): Record<string, unknown> {
  const events = Array.isArray(payload.events)
    ? (payload.events as Array<Record<string, unknown>>).map((event) => {
        if (
          event.event_type === "medication_dose" ||
          event.event_type === "treatment"
        ) {
          return {
            ...event,
            is_additional: true,
            additional_reason: reason,
          };
        }
        return event;
      })
    : payload.events;
  return {
    ...payload,
    events,
    clientEntryId: newClientId(),
  };
}

export function preserveLocalConflictPayload(
  payload: Record<string, unknown>
): Record<string, unknown> {
  return JSON.parse(JSON.stringify(payload)) as Record<string, unknown>;
}
